import { ActivatedRoute } from '@angular/router';
import { CLO029 } from 'src/app/interface/clo029';
import { PACEDService } from './../service/paced.service';
import { shareReplay, Observable, map, concatMap, combineLatest, tap } from 'rxjs';
import { SituationService } from './../service/situation.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { CLO024 } from '../interface/clo024';
import { CLO013 } from '../interface/clo013';
import * as _ from 'lodash';

@Component({
  selector: 'app-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.scss']
})
export class CertificateComponent implements OnInit, OnDestroy {

  clo024: Observable<CLO024 | undefined>;
  clo013: Observable<CLO013>;
  clo029: Observable<CLO029[]>;
  today: Date;
  constructor(private sir: SituationService, private paced: PACEDService, private meta: Meta, route: ActivatedRoute) {

    this.today = new Date();

    const proG_CODE = route.params.pipe(map(a => a['proG_CODE']), shareReplay());
    const stno = route.snapshot.params['stno'];

    this.today = new Date();
    this.clo013 = sir.getCLO013(stno).pipe(map(a => a[0]), shareReplay());
    this.clo024 =
      combineLatest([
        proG_CODE,
        sir.getCLO024(stno)
      ]).pipe(
        map(([proG_CODE, arr]) => _.find(arr, a => a.proG_CODE == proG_CODE && a.rate >= 100)),
        shareReplay()
      );

    this.clo029 = this.clo024.pipe(
      // tap(c => console.log(c)),
      concatMap(a => paced.CLO029(a?.proG_CODE as any, a?.stno))).pipe(shareReplay());

  }

  ngOnInit(): void {
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow, noarchive' });
    this.meta.updateTag({ name: 'googlebot', content: 'noindex, nofollow, noarchive' });
  }

  ngOnDestroy(): void {
    this.meta.removeTag("name='robots'");
    this.meta.removeTag("name='googlebot'");
  }

}
